<template>
    <div>
        <breadcrumb :links="crumbNav"></breadcrumb>
        <div class="row" v-if="!pageLoading">
            <div class="col">
                <div v-if="vehicle !== null">
                    <div class="row vehicle-block">
                        <div class="col-12 col-lg-6">
                            <heading
                                    :text="vehicleModel"
                                    :sub="vehicleName"></heading>
                            <div class="d-block d-lg-none">
                                <vehicle-image :source="vehicleImage" :vehicle="vehicle"></vehicle-image>
                            </div>
                            <vehicle-details></vehicle-details>
                        </div>
                        <div class="col-lg-6 d-lg-block d-none image-wrapper--side">
                            <vehicle-image :source="vehicleImage" :vehicle="vehicle"></vehicle-image>
                        </div>
                    </div>
                    <finance-filter></finance-filter>
                    <cta-block></cta-block>
                </div>
                <div v-else >
                    <h4>Unfortunately the vehicle you searched for does not exist. Please use the link above to go to the home page and find a vehicle using the provided filters.</h4>
                </div>
                <h3 class="sme-header">What's included in small business offers?</h3>
                <accordion></accordion>
            </div>
        </div>
        <loader v-else></loader>
        <disclaimer :cms-text="disclaimer"></disclaimer>
    </div>
</template>

<script>
    import {GET_DISCLAIMER, GET_SME_DESCRIPTIONS, GET_VEHICLE} from "../store/action-types";
    import Disclaimer from "../components/Disclaimer";
    import Heading from "../components/Heading";
    import FinanceFilter from "../components/VehicleDetails/FinanceFilter";
    import VehicleDetails from "../components/VehicleDetails/VehicleDetails";
    import VehicleImage from "../components/VehicleDetails/VehicleImage";
    import Breadcrumb from "../components/Breadcrumb";
    import Accordion from "../components/Accordion";
    import CtaBlock from "../components/CtaBlock";
    import Loader from "../components/Loader";

    export default {
        name: "Details",
        metaInfo () {
            return {
                title: this.vehicleModel + ' ' + this.vehicleName + ' - Small business offers',
                meta: [
                    { vmid: 'description', name: 'description', content: 'Volkswagen Group small business leasing options for ' + this.vehicleModel +  ' ' + this.vehicleName + '.' }
                ]
            }
        },

        components: {
            Loader,
            CtaBlock, Accordion, Breadcrumb, VehicleImage, VehicleDetails, FinanceFilter, Heading, Disclaimer
        },
        data() {
            return {
                busy: true,
                pageLoading: true,
                disclaimerId: 2,
                crumbNav:[
                    {name:'home', text: 'Small business offers home'}
                ],
                metaTitle: undefined
            }
        },
        methods: {
            getDisclaimer: function() {
                this.$store.dispatch(GET_DISCLAIMER, this.disclaimerId);
            },
            getSmeDescriptions: function() {
                this.$store.dispatch(GET_SME_DESCRIPTIONS);
            },
            getVehicle: function(){
                let app = this;
                this.$store.dispatch(GET_VEHICLE, {slug: this.$route.params.slug, callback: function() {
                        app.pageLoading = false;
                    }
                });
            },
            capitalize: function(value) {
                if (typeof value !== 'string') return value;
                return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
            }
        },
        computed: {
            vehicle: function() {
                return this.$store.state.VEHICLE;
            },
            disclaimer: function() {
                return this.$store.state.CMS_DISCLAIMER;
            },
            vehicleModel: function() {
                if (!this.vehicle) {
                    return '';
                }
                return this.vehicle.model.range.make.name + ' ' + this.vehicle.model.name.replace(/(PETROL|DIESEL)/gi, '');
            },
            vehicleName: function() {
                if (!this.vehicle) {
                    return '';
                }
                return this.vehicle.name + ' MY' + Math.floor(this.vehicle.model.range.year.year);
                // return this.vehicle.model.body.name + ' ' + this.vehicle.name + ' MY' + Math.floor(this.vehicle.model.range.year.year);
            },
            vehicleImage: function() {
                return (this.vehicle.model.range.mainImage) ? this.vehicle.model.range.mainImage : '';
            },
        },
        created: function(){
            this.pageLoading = true;
            this.getVehicle();
            this.getDisclaimer();
            this.getSmeDescriptions();
            this.$tracking.logPageLoad('SME-Price-List:Details');
        },
        mounted() {
            this.$scrollTo('.crumb-nav');
        }
    }
</script>

<style scoped lang="stylus">
    .image-wrapper
        &--side
            margin-top 40px
    .sme-header
        margin 4rem 0 2.7rem
</style>